export function mapKeysToValues<T extends object, K extends keyof T>(
  object: T
): Record<K, string> {
  const keys = Object.keys(object);
  const copyObject = { ...object };
  keys.forEach(key => (copyObject[key] = key));
  return copyObject as Record<K, string>;
}
